export default __webpack_public_path__ + "static/media/home.23cb8a45.svg";